import { NgModule } from "@angular/core";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { OverlayModule } from "@angular/cdk/overlay";
import { SharedModule } from "@root/shared/shared.module";
import { NzSliderModule } from "ng-zorro-antd/slider";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { CalendarComponent } from "@root/component/calendar/calendar.component";

import { LoadingComponent } from "@root/component/loading/loading.component";
import { FormUploadComponent } from "@root/component/form-upload/form-upload.component";
import { UploadVoucherComponent } from "@root/component/upload-voucher/upload-voucher.component";
import { BaseMapComponent } from "@root/component/base-map/base-map.component";
import { MapComponent } from "@root/component/map/map.component";
import { MapService } from "@root/component/map/map.service";
// import {
//   OrderMoveHouseComponent
// } from "@root/component/order-move-house/order-move-house.component";
import { ShopAgreementComponent } from "@root/component/shop-agreement/shop-agreement.component";
import { ReadOrdersComponent } from "@root/component/read-orders/read-orders.component";
import { SynchroniseCalendarComponent } from "@root/component/synchronise-calendar/synchronise-calendar.component";
import { InputWithErrorComponent } from "@root/component/input-with-error/input-with-error.component";
import { CurrencyDropdownComponent } from "@root/component/currency-dropdown/currency-dropdown.component";
import { UserDropdownComponent } from "@root/component/user-dropdown/user-dropdown.component";
// import { DaySearchComponent } from "@root/component/search-components/search-time/day-search/day-search.component";
import { SetDateComponent } from "@root/component/set-date/set-date.component";
import { ClickDateComponent } from "@root/component/set-date/click-date/click-date.component";
import { RadioButtonComponent } from "@root/component/radio-button/radio-button.component";
import { ContinuousDateComponent } from "@root/component/set-date/continuous-date/continuous-date.component";
import { SelectComponent } from "@root/component/select/select.component";
import { CalendarSelectSearchTimeComponent } from "@root/component/search-components/calendar-select-search-time/calendar-select-search-time.component";
import { CustomDatePickerComponent } from "@root/component/search-components/custom-date-picker/custom-date-picker.component";
import { LogoComponent } from "@root/component/logo/logo.component";
import { TujiaAutoReceiptComponent } from "@root/component/tujia-auto-receipt/tujia-auto-receipt.component";
// import { ZhenguoSyncMessageComponent } from "@root/component/zhenguo-sync-message/zhenguo-sync-message.component";

import { InviteComponent } from "@root/component/invite/invite.component";
import { ImageMagnifierComponent } from "@root/component/image-magnifier/image-magnifier.component";
import { SearchDateAndHouseComponent } from "@root/component/search-components/search-date-and-house/search-date-and-house.component";
import { OneMonthCalendarComponent } from "@root/component/search-components/search-date-and-house/one-month-calendar/one-month-calendar.component";
import { SearchHousesWithGroupAndTypeComponent } from "@root/component/search-components/search-date-and-house/search-houses-with-group-and-type/search-houses-with-group-and-type.component";
import { SearchDateAndHouseService } from "@root/component/search-components/search-date-and-house/search-date-and-house.service";
import { ViewVoucherComponent } from "@root/component/view-voucher/view-voucher.component";
import { TableFixedHeaderComponent } from "@root/component/table-fixed-header/table-fixed-header.component";
import { TableFixedHeaderService } from "@root/component/table-fixed-header/table-fixed-header.service";
import { QrcodeDownloadComponent } from "@root/component/qrcode-download/qrcode-download.component";
import { CouponListComponent } from "@root/component/coupon-list/coupon-list.component";
import { SystemNotificationComponent } from "@root/component/system-notification/system-notification.component";
import { ViewVoucherService } from "@root/component/view-voucher/view-voucher.service";
import { BaseImageUploadComponent } from "@root/component/base-image-upload/base-image-upload.component";
import { SimpleMultiSelectComponent } from "./simple-multi-select/simple-multi-select.component";
import { RangeTimePickerComponent } from "./range-time-picker/range-time-picker.component";
import { RangeFeePickerComponent } from "./range-fee-picker/range-fee-picker.component";
import { StickyTableComponent } from "./sticky-table/sticky-table.component";
import { RangeDatePickerComponent } from "./range-date-picker/range-date-picker.component";
import { RangePickerComponent } from "./range-picker/range-picker.component";
import { RangeQuarterComponent } from "./range-picker/range-quarter/range-quarter.component";
import { FiltersPickerComponent } from "./filters-picker/filters-picker.component";
import { V4CustomSelectComponent } from "./v4/custom-select/custom-select.component";
import { CardComponent } from "@root/component/v4/card/card.component";
import { ImageCaptionComponent } from "@root/component/v4/image-caption/image-caption.component";
import { SelectedPanelComponent } from "@root/component/v4/selected-panel/selected-panel.component";
import { V4BaseSelectorBodyComponent } from "./v4/base-selector-body/base-selector-body.component";
import { V4RangePickerComponent } from "./v4/range-picker/range-picker.component";
import { V4InputComponent } from "./v4/input/input.component";
import { V4InputNumberWithControlComponent } from "./v4/input-number-with-control/input-number-with-control.component";
import { V4CalendarComponent } from "./v4/calendar/calendar.component";
import { V4SelectableMenuItemComponent } from "./v4/selectable-menu-item/selectable-menu-item.component";
import { V4DropdownComponent } from "./v4/dropdown/dropdown.component";
import { V4CustomUploadComponent } from "./v4/custom-upload/custom-upload.component";

const ThirdpartyModules = [NzSliderModule, NzAutocompleteModule];

const Components = [
  SimpleMultiSelectComponent,
  RangePickerComponent,
  RangeTimePickerComponent,
  RangeDatePickerComponent,
  RangeQuarterComponent,
  RangeFeePickerComponent,
  FiltersPickerComponent,
];

const V4Components = [
  V4CustomSelectComponent,
  V4InputComponent,
  CardComponent,
  ImageCaptionComponent,
  SelectedPanelComponent,
  V4BaseSelectorBodyComponent,
  V4RangePickerComponent,
  V4InputNumberWithControlComponent,
  V4CalendarComponent,
  V4SelectableMenuItemComponent,
  V4DropdownComponent,
  V4CustomUploadComponent,
];

@NgModule({
  imports: [OverlayModule, SharedModule, ScrollingModule, ...ThirdpartyModules],
  declarations: [
    CalendarComponent,
    LoadingComponent,
    FormUploadComponent,
    UploadVoucherComponent,
    BaseMapComponent,
    MapComponent,
    // OrderMoveHouseComponent,
    ShopAgreementComponent,
    ReadOrdersComponent,
    SynchroniseCalendarComponent,
    InputWithErrorComponent,
    CurrencyDropdownComponent,
    UserDropdownComponent,
    // DaySearchComponent,
    SetDateComponent,
    ClickDateComponent,
    RadioButtonComponent,
    ContinuousDateComponent,
    SelectComponent,
    CalendarSelectSearchTimeComponent,
    CustomDatePickerComponent,
    LogoComponent,
    TujiaAutoReceiptComponent,
    // ZhenguoSyncMessageComponent,
    InviteComponent,
    ImageMagnifierComponent,
    SearchDateAndHouseComponent,
    OneMonthCalendarComponent,
    SearchHousesWithGroupAndTypeComponent,
    ViewVoucherComponent,
    // RelateHouseOrTypeComponent,
    TableFixedHeaderComponent,
    QrcodeDownloadComponent,
    CouponListComponent,
    SystemNotificationComponent,
    BaseImageUploadComponent,
    StickyTableComponent,
    ...Components,
    ...V4Components,
  ],
  providers: [MapService, SearchDateAndHouseService, TableFixedHeaderService, ViewVoucherService],
  exports: [
    CalendarComponent,
    LoadingComponent,
    // MultiHouseCalendarComponent,
    // MonthCalendarV2Component,
    // MonthPriceCalendarV2Component,
    // YearCalendarV2Component,
    // ChartComponent,
    // StatTransactionsComponent,
    FormUploadComponent,
    UploadVoucherComponent,
    BaseMapComponent,
    MapComponent,
    // OperateSidebarComponent,
    InputWithErrorComponent,
    CurrencyDropdownComponent,
    UserDropdownComponent,
    SetDateComponent,
    RadioButtonComponent,
    SelectComponent,
    CalendarSelectSearchTimeComponent,
    CustomDatePickerComponent,
    LogoComponent,
    ImageMagnifierComponent,
    SearchHousesWithGroupAndTypeComponent,
    TableFixedHeaderComponent,
    QrcodeDownloadComponent,
    CouponListComponent,
    SystemNotificationComponent,
    // DaySearchComponent,
    BaseImageUploadComponent,
    StickyTableComponent,
    ...Components,
    ...V4Components,
  ],
})
export class ComponentModule {
  constructor() {
    console.log("[Init Done]: ComponentModule");
  }
}
